import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_shipping_request,
    CREATE_SHIPPING_REQUEST,
    createShippingRequest,
    getAllShippingRequest,
    get_report,
    GET_REPORT,
    getItemShippingRequest,
    updateShippingRequest,
    UPDATE_SHIPPING_REQUEST, searchShippingRequest
} from '../../../redux/shipping_request';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllTypeShippingRequest} from "../../../redux/type_shipping_request";
import Card from "../../../components/card";
import Modal from "../../../components/modal";
import {get_status, URLAPI} from "../../../config";
import {getAllReasonShippingRequest} from "../../../redux/reason_shipping_request";
import {get_all_companies} from "../../../redux/company";
import {get_all_zones} from "../../../redux/zones";
import {get_all_establishments} from "../../../redux/establishment";
import CheckBox from "../../../components/check-box";


const ShippingRequestAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_shipping_request = useSelector((state) => state.shipping_request_module._get_all_shipping_request);

    const _get_all_type_shipping_request = useSelector((state) => state.type_shipping_request_module._get_all_type_shipping_request);
    const _get_all_reason_shipping_request = useSelector((state) => state.reason_shipping_request_module._get_all_reason_shipping_request);

    const _create_shipping_request = useSelector((state) => state.shipping_request_module._create_shipping_request);
    const _update_shipping_request = useSelector((state) => state.shipping_request_module._update_shipping_request);
    const _get_all_companies = useSelector((state) => state.company_module._get_all_companies);
    const _get_all_zones = useSelector((state) => state.zone_module._get_all_zones);
    const _get_all_establishments = useSelector((state) => state.establishment_module._get_all_establishments);

    const _get_report = useSelector((store) => store.shipping_request_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllShippingRequest(token));
        // eslint-disable-next-line
    }, [token, dispatch]);

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [establishment, setEstablishment] = useState([]);
    const [establishmentDestination, setEstablishmentDestination] = useState([]);
    const [typeShippingRequest, setTypeShippingRequest] = useState([]);
    const [reasonShippingRequest, setReasonShippingRequest] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [zones, setZones] = useState([]);
    const [destination, setDestination] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + " (" + element.codigo + ")"
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList])


    useEffect(() => {
        if (_get_all_type_shipping_request && _get_all_type_shipping_request.data && _get_all_type_shipping_request.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_type_shipping_request.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.descripcion,
                        joya: x.joya,
                    })
                }
            });
            setTypeShippingRequest(array);
        }
    }, [_get_all_type_shipping_request]);

    useEffect(() => {
        if (_get_all_reason_shipping_request && _get_all_reason_shipping_request.data && _get_all_reason_shipping_request.data.datos) {
            let array = _get_all_reason_shipping_request.data.datos.filter(x => x.activo === true);
            setReasonShippingRequest(array);
        }
    }, [_get_all_reason_shipping_request]);

    useEffect(() => {
        if (_get_all_companies && _get_all_companies.data && _get_all_companies.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_companies.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.nombre
                    })
                }
            });
            setCompanies(array);
        }
    }, [_get_all_companies]);

    useEffect(() => {
        if (_get_all_zones && _get_all_zones.data && _get_all_zones.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_zones.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.nombre
                    })
                }
            });
            setZones(array);
        }
    }, [_get_all_zones]);

    useEffect(() => {
        if (_get_all_establishments && _get_all_establishments.data && _get_all_establishments.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_establishments.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.nombre + " (" + x.codigo + ")"
                    })
                }
            });
            setEstablishmentDestination(array);
        }
    }, [_get_all_establishments]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Empresa', id: 2},
        {name: 'Zona', id: 3},
        {name: 'Establecimiento', id: 4},
        {name: 'Número de guía', id: 5},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_establishment: false,
        id_establishment: 0,
        visible_company: false,
        id_company: 0,
        visible_zone: false,
        id_zone: 0,
        visible_guide_number: false,
        guide_number: '',
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_establecimiento: 0,
        id_establecimiento_destino: 0,
        descripcion: "",
        tipos: [],
        joyas: [],
        costo_origen: false,
        costo_destino: false,
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_shipping_request.status === 201) {
            toast.success("Solicitud de envío creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_shipping_request(CREATE_SHIPPING_REQUEST));
            dispatch(getAllShippingRequest(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_shipping_request.status !== 0) {
            toast.error(_create_shipping_request.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_shipping_request(CREATE_SHIPPING_REQUEST));
            setIsLoading(false);
        }
    }, [_create_shipping_request, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_shipping_request && _get_all_shipping_request.data && _get_all_shipping_request.data.datos) {
            setDatas(_get_all_shipping_request.data.datos);
        }

    }, [_get_all_shipping_request, count, props]);

    const loadFunc = () => {
        if (_get_all_shipping_request.data.datos) {
            if (_get_all_shipping_request.data.datos.length > count) {
                const ordenado = _get_all_shipping_request.data.datos.sort((a, b) => {
                    return new Date(b.fecha_creacion + ' 00:00:00') - new Date(a.fecha_creacion + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setEstablishmentSelectFilter([]);
        setCompanySelectFilter([]);
        setZoneSelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_shipping_request.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_company: false,
                id_company: 0,
                visible_zone: false,
                id_zone: 0,
                visible_guide_number: false,
                guide_number: '',
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3' || e.target.value === '4' || e.target.value === '5') {
            if (e.target.value === '2') {
                dispatch(get_all_companies(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: true,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_guide_number: false,
                    guide_number: '',
                });
            }
            if (e.target.value === '3') {
                dispatch(get_all_zones(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: true,
                    id_zone: 0,
                    visible_guide_number: false,
                    guide_number: '',
                });
            }
            if (e.target.value === '4') {
                setOtherFilter({
                    visible_establishment: true,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_guide_number: false,
                    guide_number: '',
                });
            }
            if (e.target.value === '5') {
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_guide_number: true,
                    guide_number: '',
                });
            }
        } else {
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_company: false,
                id_company: 0,
                visible_zone: false,
                id_zone: 0,
                visible_guide_number: false,
                guide_number: '',
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_establecimiento" || e.target.name === "id_establecimiento_destino") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    // const getTypes = async (id_establecimiento) => {
    //     const params = '?id_establecimiento=' + id_establecimiento + '&&buscar=1'
    //     const response = await searchTypes(token, params)
    //     if (response && response.data && response.data.datos) {
    //         let options = response.data.datos.map((item) => {
    //             return {
    //                 value: item.id,
    //                 label: item.nombres + ' ' + item.apellidos,
    //             };
    //         });
    //         setTypes(options);
    //     }
    // }

    const [establishment_select, setEstablishmentSelect] = useState([]);
    const [establishment_destination_select, setEstablishmentDestinationSelect] = useState([]);

    const handleChangeEstablishment = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento']: parseInt(e.value),
        });
        setEstablishmentSelect(e);
    }

     const handleChangeEstablishmentDestination = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento_destino']: parseInt(e.value),
        });
        setEstablishmentDestinationSelect(e);
    }


    const [type_shipping_request_select, setTypeShippingRequestSelect] = useState([]);
    const [visible, setVisible] = useState(false);

    const handleChangeTypeShippingRequest = (e) => {
        if (e.joya === true) {
            setVisible(true);
        } else {
            setVisible(false);
            setJewerlys([]);
        }
        // let joya = e.filter((item) => item.joya === true);

        // if (joya.length > 0) {
        //     setVisible(true);
        // } else {
        //     setVisible(false);
        //     setJewerlys([]);
        // }
        setTypeShippingRequestSelect([e]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        let tipos = [];
        let joya = false;
        type_shipping_request_select.forEach(em => {
            tipos.push(em.value);
            joya = em.joya;
        });

        form.tipos = tipos;
        form.joyas = jewerlys;

        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento de origen");
            setIsLoading(false);
            return;
        }
        if (form.id_establecimiento_destino === 0) {
            toast.error("Debe seleccionar el establecimiento de destino");
            setIsLoading(false);
            return;
        }
        if (permisos.filter(element => element.codigo === "taller_shipping_request").length === 0 && permisos.filter(element => element.codigo === "operacion_shipping_request").length === 0) {
            if (form.costo_origen === false && form.costo_destino === false) {
                toast.error("Debe seleccionar el establecimiento que asume el costo de envío");
                setIsLoading(false);
                return;
            }
        }
        if (form.descripcion === "") {
            toast.error("Debe ingresar una descripción");
            setIsLoading(false);
            return;
        }
        if (form.tipos.length === 0) {
            toast.error("Debe seleccionar al menos un tipo de solicitud de envío");
            setIsLoading(false);
            return;
        }
        if (joya === true) {
            if (jewerlys.length === 0) {
                toast.error("Debe ingresar al menos un producto");
                setIsLoading(false);
                return;
            }
        }
        dispatch(createShippingRequest(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_shipping_request.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_shipping_request.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.establecimiento_codigo.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_shipping_request.data.datos.filter(x => {
                    if (x.fecha_creacion) {
                        let fecha = new Date(x.fecha_creacion);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    const handleFilterGuideNumber = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_shipping_request.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let numeroGuia = e.target.value;
        numeroGuia = numeroGuia.trim();
        let re = new RegExp(numeroGuia, "i");
        // eslint-disable-next-line
        let filtro = _get_all_shipping_request.data.datos.filter(element => {
            if (element.numero_guia && element.numero_guia.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_shipping_request(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_shipping_request(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_establecimiento': other_filter.id_establishment,
            'id_empresa': other_filter.id_company,
            'id_zona': other_filter.id_zone,
            'numero_guia': other_filter.guide_number,
        }, token));

    }

    const [establishment_select_filter, setEstablishmentSelectFilter] = useState([]);

    const handleChangeEstablishmentFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_establishment': parseInt(e.value),
        });
        let va = _get_all_shipping_request.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.value));
        setDatas(va);
        setEstablishmentSelectFilter(e);
    }

    const [company_select_filter, setCompanySelectFilter] = useState([]);

    const handleChangeCompanyFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_company': parseInt(e.value),
        });
        let va = _get_all_shipping_request.data.datos.filter(x => parseInt(x.id_empresa) === parseInt(e.value));
        setDatas(va);
        setCompanySelectFilter(e);
    }

    const [zone_select_filter, setZoneSelectFilter] = useState([]);

    const handleChangeZoneFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_zone': parseInt(e.value),
        });
        let va = _get_all_shipping_request.data.datos.filter(x => parseInt(x.id_zona) === parseInt(e.value));
        setDatas(va);
        setZoneSelectFilter(e);
    }

    const initSelect = {
        id: 0,
        secuencial: "",
        establecimiento: "",
        establecimiento_codigo: "",
        establecimiento_destino: "",
        establecimiento_destino_codigo: "",
        descripcion: "",
        motivo: "",
        observacion: "",
        estado: "",
        tipos: [],
        joyas: [],
        totalPeso:0,
        totalCosto:0,
        fecha_creacion: "",
        fecha_aprobacion: "",
        fecha_aprobacion_zonal: "",
        fecha_despacho: "",
        fecha_recibe: "",
        link: "",
        file: "",
        order_number: false,
        costo_origen: false,
        costo_destino: false,
        despachado: false,
        recibido: false,
        numero_guia: "",
    };

    const [DataSelected, setDataSelected] = useState(initSelect);
    const [modalValidar, setModalValidar] = useState(false);
    const [modalCost, setModalCost] = useState(false);
    const [modalDecline, setModalDecline] = useState(false);
    const [modalJewerly, setModalJewerly] = useState(false);
    const [costEstablishmentOrigin, setCostEstablishmentOrigin] = useState(false);
    const [costEstablishmentDestination, setCostEstablishmentDestination] = useState(false);
    const [link, setLink] = useState('');
    const [guideNumber, setGuideNumber] = useState('');
    const [archivo, setArchivo] = useState('');
    const [observation, setObservation] = useState('');
    const [idReason, setIdReason] = useState(0);

    const onItemClickListener = async (item) => {
        const response = await getItemShippingRequest(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_shipping_request.status === 200) {
            toast.success(_update_shipping_request.data.mensaje);
            dispatch(clear_shipping_request(UPDATE_SHIPPING_REQUEST));
            // eslint-disable-next-line
            dispatch(getAllShippingRequest(token));
            setIsLoading(false);
            setModalValidar(false);
            setModalDecline(false);
            setModalCost(false);
            setShowDetail(false);
        } else if (_update_shipping_request.status !== 0) {
            toast.error(_update_shipping_request.message);
            dispatch(clear_shipping_request(UPDATE_SHIPPING_REQUEST));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_shipping_request, dispatch])

    const handleSubmitApproval = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateShippingRequest(token, DataSelected.id, {"estado": "SOLICITUD EN CURSO", "tipo": "1"}))
    }

    const handleSubmitDispatch = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateShippingRequest(token, DataSelected.id, {"estado": "SOLICITUD DESPACHADA", "tipo": "1"}))
    }

    const handleSubmitReceive = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateShippingRequest(token, DataSelected.id, {"estado": "SOLICITUD RECIBIDA", "tipo": "1"}))
    }

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!guideNumber) {
            toast.error("Debe ingresar el número de guía");
            setIsLoading(false);
            return;
        }
        if (!link) {
            toast.error("Debe ingresar el link");
            setIsLoading(false);
            return;
        }
        if (!archivo) {
            toast.error("Debe seleccionar la guia");
            setIsLoading(false);
            return;
        }
        dispatch(updateShippingRequest(token, DataSelected.id, {'numero_guia': guideNumber, 'archivo': archivo, 'link': link, 'estado': 'SOLICITUD APROBADA', "tipo": "1"}))
    }

    const handleDeclineSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (idReason === 0) {
            toast.error("Debe seleccionar un motivo");
            setIsLoading(false);
            return;
        }
        dispatch(updateShippingRequest(token, DataSelected.id, {"estado": "SOLICITUD RECHAZADA", "observacion": observation, "id_motivo": idReason, "tipo": "1"}))
    }

    const handleSubmitCost = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (costEstablishmentOrigin === false && costEstablishmentDestination === false) {
            toast.error("Debe seleccionar el establecimiento que asume el costo de envío");
            setIsLoading(false);
            return;
        }
        dispatch(updateShippingRequest(token, DataSelected.id, {"costo_origen": costEstablishmentOrigin, "costo_destino": costEstablishmentDestination, "tipo": "2"}))
    }

     // eslint-disable-next-line
    const initJewelry = {
        sku: '',
        peso: 0,
        costo: 0,
        numero_orden: '',
    };

    // eslint-disable-next-line
    const [jewerly, setJewerly] = useState(initJewelry);
    const [totalPeso, setTotalPeso] = useState(0);
    const [totalCosto, setTotalCosto] = useState(0);
    const [jewerlys, setJewerlys] = useState([]);

    const handleChangeJewerly = (e) => {
        if (e.target.name === "peso" || e.target.name === "costo") {
            setJewerly({
                ...jewerly,
                [e.target.name]: parseFloat(e.target.value),
            });
        } else {
            setJewerly({
                ...jewerly,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleJewerlySubmit = (e) => {
        e.preventDefault();
        if (jewerly.sku === '') {
            toast.error("Debe ingresar el sku");
            return;
        }
        if (jewerly.peso === 0) {
            toast.error("Debe ingresar el peso");
            return;
        }
        if (jewerly.costo === 0) {
            toast.error("Debe ingresar el costo");
            return;
        }
        if (jewerly.numero_orden === '' && permisos.filter(element => element.codigo === "taller_shipping_request").length > 0) {
            toast.error("Debe ingresar el número de orden");
            return;
        }
        setJewerlys([...jewerlys, jewerly]);
        setTotalPeso((parseFloat(totalPeso) + parseFloat(jewerly.peso)).toFixed(2));
        setTotalCosto((parseFloat(totalCosto) + parseFloat(jewerly.costo)).toFixed(2));
        setModalJewerly(false);
        setJewerly(initJewelry);
    }

    async function search_shipping_request(destino) {
        const params = '?destino=' + destino
        const response = await searchShippingRequest(token, params)
        if (response.status === 200) {
            setDatas(response.data.datos)
        }
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Solicitud de envíos"
                            items={[{label: "Listado solicitudes de envíos", link: "/solicitudes-envios"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_shippingrequest").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        dispatch(getAllTypeShippingRequest(token));
                                                        dispatch(get_all_establishments(token));
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm);
                                                        setJewerlys([]);
                                                        setShowOverlay(!showSibarRight);
                                                        setEstablishmentSelect([]);
                                                        setEstablishmentDestinationSelect([]);
                                                        setTypeShippingRequestSelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-shipping_requesta"
                                                    name="filtro-shipping_requesta"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_company && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Empresa</label>
                                                                <Select
                                                                    options={companies}
                                                                    isMulti={false}
                                                                    onChange={handleChangeCompanyFilter}
                                                                    value={company_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_zone && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Zona</label>
                                                                <Select
                                                                    options={zones}
                                                                    isMulti={false}
                                                                    onChange={handleChangeZoneFilter}
                                                                    value={zone_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_guide_number && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    label="Número de guía"
                                                                    name="guide_number"
                                                                    onChange={handleFilterGuideNumber}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_establishment && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Establecimiento</label>
                                                                <Select
                                                                    options={establishment}
                                                                    isMulti={false}
                                                                    onChange={handleChangeEstablishmentFilter}
                                                                    value={establishment_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {(permisos.filter(element => element.codigo === "add_shippingrequest").length > 0) ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''} div_request_shipping`}
                                             style={{
                                                 overflowY: 'scroll',
                                                 width: "55% !important"
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="shipping_requesta">
                                                        Nueva solicitud de envío
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimiento de origen</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            {((permisos.filter(element => element.codigo === "taller_shipping_request").length === 0 && permisos.filter(element => element.codigo === "operacion_shipping_request").length === 0)) &&
                                                                <>
                                                                <CheckBox label="Asume costo de envío (origen)" name="costo_origen" id="costo_origen" onChange={(e) => {
                                                                    setForm({
                                                                        ...form,
                                                                        costo_origen: e.target.checked,
                                                                        costo_destino: !e.target.checked,
                                                                    })
                                                                }} state={form.costo_origen}/>
                                                                <br/>
                                                                </>
                                                            }
                                                            <label className="form-label">Establecimiento de destino</label>
                                                            <Select
                                                                options={establishmentDestination}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishmentDestination}
                                                                value={establishment_destination_select}
                                                            />
                                                            <br/>
                                                            {((permisos.filter(element => element.codigo === "taller_shipping_request").length === 0 && permisos.filter(element => element.codigo === "operacion_shipping_request").length === 0)) &&
                                                                <>
                                                                <CheckBox label="Asume costo de envío (destino)" name="costo_destino" id="costo_destino" onChange={(e) => {
                                                                    setForm({
                                                                        ...form,
                                                                        costo_origen: !e.target.checked,
                                                                        costo_destino: e.target.checked,
                                                                    })
                                                                }} state={form.costo_destino}/>
                                                                <br/>
                                                                </>
                                                            }
                                                            <TextArea
                                                                id="descripcion"
                                                                name="descripcion"
                                                                label="Descripción"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.descripcion}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Tipo de solicitud de envío</label>
                                                            <Select
                                                                options={typeShippingRequest}
                                                                isMulti={false}
                                                                onChange={handleChangeTypeShippingRequest}
                                                                value={type_shipping_request_select}
                                                            />
                                                            {visible &&
                                                                <>
                                                                    <br/>
                                                                    <div className="text-right">
                                                                        <Button
                                                                            text="Añadir joya"
                                                                            onChange={() => {
                                                                                setModalJewerly(true);
                                                                            }}
                                                                            theme="warning"
                                                                            type="button"
                                                                            disabled={isLoading}
                                                                        />
                                                                    </div>
                                                                    <div className="mt-1">
                                                                        {jewerlys.length > 0 &&
                                                                            <table className="table table-striped">
                                                                                <tr>
                                                                                    <th className="text_request_shipping">#</th>
                                                                                    <th className="text_request_shipping">SKU</th>
                                                                                    {(permisos.filter(element => element.codigo === "taller_shipping_request").length > 0) &&
                                                                                        <th className="text_request_shipping">No. Orden</th>
                                                                                    }
                                                                                    <th className="text_request_shipping">Peso</th>
                                                                                    <th className="text_request_shipping">Costo</th>
                                                                                    <th className="text_request_shipping"></th>
                                                                                </tr>
                                                                                {jewerlys.map((j, index) => (
                                                                                    <tr>
                                                                                        <td className="text_request_shipping">{index + 1}</td>
                                                                                        <td className="text_request_shipping">{j.sku}</td>
                                                                                        {(permisos.filter(element => element.codigo === "taller_shipping_request").length > 0) &&
                                                                                            <td className="text_request_shipping">{j.numero_orden}</td>
                                                                                        }
                                                                                        <td className="text_request_shipping text-right">{j.peso}</td>
                                                                                        <td className="text_request_shipping text-right">{j.costo}</td>
                                                                                        <td className="text_request_shipping text-right">
                                                                                            {/*eslint-disable-next-line*/}
                                                                                            <a href="#" onClick={() => {
                                                                                                let v = jewerlys[index];
                                                                                                setTotalPeso(parseFloat(totalPeso) - parseFloat(v.peso));
                                                                                                setTotalCosto(parseFloat(totalCosto) - parseFloat(v.costo));
                                                                                                jewerlys.splice(index, 1);
                                                                                            }}>
                                                                                                <i className="badge-circle badge-circle-light-danger bx bxs-trash"/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                                <tr>
                                                                                    <th colSpan={(permisos.filter(element => element.codigo === "taller_shipping_request").length > 0) ? 3 : 2} className="text_request_shipping">Totales</th>
                                                                                    <th className="text_request_shipping text-right">{totalPeso}</th>
                                                                                    <th className="text_request_shipping text-right">{totalCosto}</th>
                                                                                </tr>
                                                                            </table>
                                                                        }
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR SHIPPING_REQUEST
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="pl-3 pr-3 d-flex mt-1 mb-1">
                                                    <Button
                                                        text="Mis envíos realizados"
                                                        onChange={() => {
                                                            setDestination(false);
                                                            search_shipping_request(false)
                                                        }}
                                                        theme="primary"
                                                        classes="button_div1"
                                                        type="button"
                                                        disabled={isLoading}
                                                    />
                                                    { permisos && permisos.filter(x => x.codigo === 'shipping_request_be_received').length > 0 &&
                                                    <Button
                                                        text="Solicitudes por recibir"
                                                        onChange={() => {
                                                            setDestination(true);
                                                            search_shipping_request(true)
                                                        }}
                                                        theme="warning"
                                                        classes="button_div1"
                                                        type="button"
                                                        disabled={isLoading}
                                                    />
                                                    }
                                                </div>
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o secuencial"} onChange={handleSearch}/>
                                                                </div>
                                                                { permisos && permisos.filter(x => x.codigo === 'generate_excel_shipping_request').length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.secuencial}
                                                                    subtitle={item.descripcion}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    <small>{"Origen: " + item.establecimiento + ' (' + item.establecimiento_codigo + ')'}</small><br/>
                                                                                    <small>{"Destino: " + item.establecimiento_destino + ' (' + item.establecimiento_destino_codigo + ')'}</small>
                                                                                </div>
                                                                                <div className="email-items">
                                                                                    <span>Fecha: </span>{item.fecha_creacion}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}
                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.descripcion}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.establecimiento) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Origen: </h6>{DataSelected.establecimiento + ' (' + DataSelected.establecimiento_codigo + ')'}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.establecimiento_destino) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Destino: </h6>{DataSelected.establecimiento_destino + ' (' + DataSelected.establecimiento_destino_codigo + ')'}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.costo_origen || DataSelected.costo_destino) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Asume el costo de envío</h6>
                                                                            {DataSelected.costo_origen ?
                                                                                DataSelected.establecimiento + ' (' + DataSelected.establecimiento_codigo + ')'
                                                                            :
                                                                                DataSelected.establecimiento_destino + ' (' + DataSelected.establecimiento_destino_codigo + ')'
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_creacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de creación: </h6>{DataSelected.fecha_creacion}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 mb-1">
                                                                        <h6>Tipos</h6>
                                                                        <div className="row">
                                                                            {DataSelected.tipos.map((item,) =>
                                                                                <div className="col-md-4 col-12">
                                                                                    <div className="p-1" style={{background: "#f3f0f0"}}>
                                                                                        <span style={{background: "#f3f0f0"}}>{item.nombre}</span>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {(DataSelected.fecha_aprobacion_zonal) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de aprobación (zonal): </h6>{DataSelected.fecha_aprobacion_zonal}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_aprobacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de aprobación: </h6>{DataSelected.fecha_aprobacion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_despacho) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de despacho: </h6>{DataSelected.fecha_despacho}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_recibe) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha cuando recibió: </h6>{DataSelected.fecha_recibe}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.numero_guia) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Número de guía: </h6>{DataSelected.numero_guia}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.link && permisos.filter(x => x.codigo === 'dowload_shipping_request').length > 0) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Link</h6>
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={DataSelected.link} target="_blank">{DataSelected.link}</a>
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.file && permisos.filter(x => x.codigo === 'dowload_shipping_request').length > 0) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Guía</h6>
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.file}`} target="_blank">
                                                                                <img
                                                                                    className="logo"
                                                                                    src="/base/app-assets/images/icon/pdf.png"
                                                                                    alt="logo"
                                                                                    style={{width: "100px",height: "auto", }}
                                                                                />
                                                                            </a>

                                                                        </div>
                                                                    }
                                                                    {(DataSelected.motivo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Motivo: </h6>{DataSelected.motivo}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.observacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.joyas.length > 0) &&
                                                                        <div className="col-12 mt-2">
                                                                            <h6>Joyas</h6>
                                                                            <table className="table table-bordered">
                                                                                <tr>
                                                                                    <th className="text-center">#</th>
                                                                                    <th className="text-center">SKU</th>
                                                                                    {DataSelected.order_number &&
                                                                                        <th className="text-center">No. Orden</th>
                                                                                    }
                                                                                    <th className="text-center">Peso</th>
                                                                                    <th className="text-center">Costo</th>
                                                                                </tr>
                                                                                {DataSelected.joyas.map((j, index) => (
                                                                                    <tr>
                                                                                        <td className="text-center">{index + 1}</td>
                                                                                        <td>{j.sku}</td>
                                                                                        {DataSelected.order_number &&
                                                                                            <td>{j.numero_orden}</td>
                                                                                        }
                                                                                        <td className="text-right">{j.peso}</td>
                                                                                        <td className="text-right">{j.costo}</td>
                                                                                    </tr>
                                                                                ))}
                                                                                <tr>
                                                                                <th colSpan={DataSelected.order_number ? 3 : 2}>Totales</th>
                                                                                    <th className="text-right">{DataSelected.totalPeso}</th>
                                                                                    <th className="text-right">{DataSelected.totalCosto}</th>
                                                                                </tr>
                                                                            </table>
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {(permisos.filter(x => x.codigo === 'update_cost_shipping_request').length > 0) &&
                                                                            <Button
                                                                                text="Costo de envío"
                                                                                onChange={() => {
                                                                                    setCostEstablishmentOrigin(false);
                                                                                    setCostEstablishmentDestination(false);
                                                                                    setModalCost(true);
                                                                                }}
                                                                                theme="info"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'decline_admin_shipping_request').length > 0) &&
                                                                            <Button
                                                                                text="Rechazar solicitud"
                                                                                onChange={() => {
                                                                                    dispatch(getAllReasonShippingRequest(token));
                                                                                    setIdReason(0);
                                                                                    setObservation('');
                                                                                    document.getElementById("motivo").selectedIndex = 0;
                                                                                    setModalDecline(true);
                                                                                }}
                                                                                theme="danger"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'approval_shipping_request').length > 0 && DataSelected.estado === "SOLICITUD CREADA") &&
                                                                            <>
                                                                                {(permisos.filter(x => x.codigo === 'decline_admin_shipping_request').length === 0) &&
                                                                                <Button
                                                                                    text="Rechazar solicitud"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonShippingRequest(token));
                                                                                        setIdReason(0);
                                                                                        setObservation('');
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                }
                                                                                <Button
                                                                                    text="Aprobar solicitud"
                                                                                    onChange={handleSubmitApproval}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'valid_shipping_request').length > 0 && DataSelected.estado === "SOLICITUD EN CURSO") &&
                                                                            <>
                                                                                {(permisos.filter(x => x.codigo === 'decline_admin_shipping_request').length === 0) &&
                                                                                <Button
                                                                                    text="Rechazar solicitud"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonShippingRequest(token));
                                                                                        setIdReason(0);
                                                                                        setObservation('');
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                }
                                                                                <Button
                                                                                    text="Validar solicitud"
                                                                                    onChange={() => {
                                                                                        setArchivo('');
                                                                                        setGuideNumber('');
                                                                                        setLink('https://www.tramaco.com.ec/rastreo.html');
                                                                                        setModalValidar(true);
                                                                                    }}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'dispatch_shipping_request').length > 0 && DataSelected.estado === "SOLICITUD APROBADA" && destination === false) &&
                                                                            <Button
                                                                                text="Despachar solicitud de envío"
                                                                                onChange={handleSubmitDispatch}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'receive_shipping_request').length > 0 && DataSelected.estado === "SOLICITUD DESPACHADA" && destination === true) &&
                                                                            <Button
                                                                                text="Recibir solicitud de envío"
                                                                                onChange={handleSubmitReceive}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modalValidar}>
                <form onSubmit={handleUpdateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Validar</h5>
                        <div className="form-group">
                            <Input
                                name="numero_guia"
                                label="Número de guía"
                                onChange={(e) => setGuideNumber(e.target.value)}
                                value={guideNumber}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Link"
                                name="link"
                                onChange={(e) => setLink(e.target.value)}
                                value={link}
                                rows={5}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Guía"
                                name="archivo"
                                type="file"
                                accept=".docx,.pdf"
                                onChange={(e) => setArchivo(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalValidar(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalCost}>
                <form onSubmit={handleSubmitCost}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Seleccione quién asume el costo de envío</h5>
                        <div className="form-group">
                            <small>Establecimiento de Origen</small>
                            <CheckBox label={DataSelected.establecimiento + ' (' + DataSelected.establecimiento_codigo + ')'} name="costEstablishmentOrigin" id="costEstablishmentOrigin" onChange={(e) => {
                                setCostEstablishmentOrigin(e.target.checked);
                                setCostEstablishmentDestination(!e.target.checked);
                            }} state={costEstablishmentOrigin}/>
                        </div>
                        <div className="form-group">
                            <small>Establecimiento de Destino</small>
                            <CheckBox label={DataSelected.establecimiento_destino + ' (' + DataSelected.establecimiento_destino_codigo + ')'} name="costEstablishmentDestination" id="costEstablishmentDestination" onChange={(e) => {
                                setCostEstablishmentOrigin(!e.target.checked);
                                setCostEstablishmentDestination(e.target.checked);
                            }} state={costEstablishmentDestination}/>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalCost(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalDecline}>
                <form onSubmit={handleDeclineSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Rechazar</h5>
                        <div className="form-group">
                            <label>Motivo</label>
                            <SelectInput
                                id="motivo"
                                label="motivo"
                                name="idReason"
                                onChange={(e) => setIdReason(parseInt(e.target.value))}
                                options={reasonShippingRequest ? reasonShippingRequest.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Observación (Opcional)"
                                name="observacion"
                                onChange={(e) => setObservation(e.target.value)}
                                value={observation}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalJewerly}>
                <form onSubmit={handleJewerlySubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Añadir joya</h5>
                        <div className="form-group">
                            <Input
                                name="sku"
                                label="Sku"
                                onChange={handleChangeJewerly}
                                value={jewerly.sku}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Peso"
                                name="peso"
                                value={jewerly.peso}
                                onChange={handleChangeJewerly}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Costo"
                                name="costo"
                                value={jewerly.costo}
                                onChange={handleChangeJewerly}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        {(permisos.filter(element => element.codigo === "taller_shipping_request").length > 0) &&
                            <div className="form-group">
                                <Input
                                    name="numero_orden"
                                    label="Número de orden"
                                    onChange={handleChangeJewerly}
                                    value={jewerly.numero_orden}
                                />
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Añadir joya
                        </button>
                        <button type="button" onClick={() => {
                            setModalJewerly(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default ShippingRequestAdmin;
